import cx from 'classnames';
import type { IconComponentProps } from '@THC/components/Icon';
import { InfoIcon } from '@THC/components/Icons/Info';

import type { TooltipProps } from 'Storybook/core/Tooltip';
import { Tooltip } from 'Storybook/core/Tooltip';

import styles from './IconTooltip.module.scss';

interface IconTooltipProps extends Omit<TooltipProps, 'children'> {
	content: React.ReactNode;
	icon?: React.FC<IconComponentProps>;
	iconProps?: IconComponentProps;
	maxWidth?: string;
	triggerClassName?: string;
	triggerProps?: Record<string, string>;
}

export const IconTooltip: React.FC<IconTooltipProps> = ({
	content,
	icon: Icon = InfoIcon,
	iconProps,
	maxWidth = '250px',
	side = 'top',
	triggerClassName,
	triggerProps,
	...props
}) => (
	<Tooltip
		openOnTap
		content={
			<div className={styles.tooltip} style={{ maxWidth }}>
				{content}
			</div>
		}
		side={side}
		{...props}
	>
		<div className={cx(styles.infoIcon, triggerClassName)} data-testid="tooltip-trigger" {...triggerProps}>
			<Icon filled={false} size="small" {...iconProps} />
		</div>
	</Tooltip>
);
